function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import firebase from 'firebase/app';
import 'firebase/database';
import { useEffect, useState } from 'react';
const firebaseConfigBackup = {
  apiKey: 'AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M',
  authDomain: 'atresmicroserviciosdes.firebaseapp.com',
  databaseURL: 'https://atresmicroserviciosdes-tvbackup.firebaseio.com/',
  projectId: 'atresmicroserviciosdes',
  storageBucket: 'atresmicroserviciosdes.appspot.com',
  messagingSenderId: '574492392308'
};
const app = firebase.initializeApp(firebaseConfigBackup, 'tvbackup');

const updateKey = (reference, key, data) => {
  if (data !== undefined) {
    if (key) {
      reference.update({
        [key]: data
      });
    } else {
      reference.update(data);
    }
  }
};

const INITIAL_ANTENA3_STATE = {
  location: null,
  left: [],
  right: []
};
export const useAntena3Data = () => {
  const _useState = useState(INITIAL_ANTENA3_STATE),
        _useState2 = _slicedToArray(_useState, 2),
        firebaseData = _useState2[0],
        setFirebaseData = _useState2[1];

  const location = firebaseData.location,
        left = firebaseData.left,
        right = firebaseData.right;
  const reference = firebase.database(app).ref('/antena3/');

  const setLocation = location => {
    reference.update({
      location,
      left: [],
      right: []
    });
  };

  const setLeft = updateKey.bind(null, reference, 'left');
  const setRight = updateKey.bind(null, reference, 'right');
  const reset = updateKey.bind(null, reference, null, INITIAL_ANTENA3_STATE);
  useEffect(() => {
    reference.on('value', rawData => {
      const data = rawData.val();
      setFirebaseData({
        location: data.location || null,
        left: data.left || [],
        right: data.right || []
      });
    });
    return () => {
      reference.off();
    };
  }, [reference]);
  return {
    location,
    left,
    right,
    setLocation,
    setLeft,
    setRight,
    reset
  };
};
export const useLaSextaData = () => {
  const _useState3 = useState([]),
        _useState4 = _slicedToArray(_useState3, 2),
        firebaseData = _useState4[0],
        setFirebaseData = _useState4[1];

  const reference = firebase.database(app).ref('/lasexta/');
  useEffect(() => {
    reference.on('value', data => setFirebaseData(data.val()));
    return () => {
      reference.off();
    };
  }, [reference]);
  return {
    parties: firebaseData,
    setParties: setFirebaseData
  };
};